import {
  IWorkflow,
  IWorkflowProduct,
} from 'interfaces/runOrchestration/workflowRow';

export const isSameWorkflowRow = (
  firstRow: IWorkflow | IWorkflowProduct,
  secondRow: IWorkflow | IWorkflowProduct
): boolean => {
  if (firstRow.isProduct !== secondRow.isProduct) {
    return false;
  }

  return firstRow.isProduct
    ? (firstRow as IWorkflowProduct).productId ===
        (secondRow as IWorkflowProduct).productId
    : firstRow.id === secondRow.id;
};